// extracted by mini-css-extract-plugin
export default {"formControl":"formControl--LfwXn","invalid":"invalid--qRTyR","big":"big--cxb47","arrows":"arrows--tMXUP"};